import React from 'react';

import MenuLessErrorTemplate from './menuLessErrorTemplate';

const Page404 = () => {
    return <MenuLessErrorTemplate errorCode={404} />;
};
export default Page404;
